import React, { useState, useEffect } from "react";
import { Accept } from 'react-dropzone';
import Api from "../../../network/Api";
import Toolbox from "../../Shared/Toolbox";
import Uploader, { FileResponse } from "./Uploader";

export type ImporterProps = {
  accept: Accept,
  onCancel: () => void,
  onUploaded: () => void
}

const Importer = (props: ImporterProps) => {

  const [file, setFile] = useState<FileResponse>();
  const [isUploading, shouldUpload] = useState(false);

  useEffect(() => {
    if (!isUploading || typeof(file) === "undefined") { return }
    Api.put("/uploads", file).then(result => {
      if (result?.error) {
        shouldUpload(false);
        return
      }
      props.onUploaded();
    })
  }, [isUploading]);

  return <Toolbox maxWidth="sm" onClose={props.onCancel} title={`Import lessons learned from ${Object.entries(props.accept).map(([key, values]) => {
          return values;
        })} file`}>

    { /* TODO: add instructions for MS whiteboard */ }  
    
    <Uploader accept={props.accept} onUploaded={props.onUploaded} />
  </Toolbox>
}

export default Importer;